import {useLayoutEffect, useState} from 'react';
import {usesTouchActivityLayout} from './touch-layout';
import './activity-page-viewport.scss';
import './mobile-activity-page.scss';

// The activity has one document viewport. Below a readable desktop minimum,
// scroll the browser page; never create a second scroll container on the board.
export default function useActivityPageViewport(ref) {
 const [mobile, setMobile] = useState(usesTouchActivityLayout);
 useLayoutEffect(()=>{
  const wrapper=ref.current?.closest('.template-wrapper');
  if(!wrapper)return;
  const body=document.body,html=document.documentElement;
  const previousX=window.scrollX,previousY=window.scrollY;
  wrapper.classList.add('template-wrapper--activity-page');
  body.classList.add('activity-page-open');html.classList.add('activity-page-open');
  const coarse=window.matchMedia('(hover: none) and (pointer: coarse)');
  let previousSize='';
  const sync=()=>{
   const touch=usesTouchActivityLayout();
   setMobile(touch);
   wrapper.classList.toggle('template-wrapper--math-mobile',touch);
   body.classList.toggle('math-mobile-open',touch);html.classList.toggle('math-mobile-open',touch);
   wrapper.style.setProperty('--activity-scroll-x',`${-window.scrollX}px`);wrapper.style.setProperty('--activity-scroll-y',`${-window.scrollY}px`);
   const viewport=window.visualViewport;
   const width=touch?viewport?.width||window.innerWidth:window.innerWidth;
   const height=touch?viewport?.height||window.innerHeight:window.innerHeight;
   wrapper.style.setProperty('--math-viewport-width',`${width}px`);
   wrapper.style.setProperty('--math-viewport-height',`${height}px`);
   const left=touch?viewport?.offsetLeft||0:0,top=touch?viewport?.offsetTop||0:0;
   wrapper.style.setProperty('--math-viewport-left',`${left}px`);
   wrapper.style.setProperty('--math-viewport-top',`${top}px`);
   const size=`${width}:${height}:${left}:${top}`;
   // A finger held down through rotation/keyboard resizing must not commit a
   // drop against a different coordinate system. Existing board cancel handlers
   // already discard the gesture without changing the learner's saved scene.
   if(previousSize&&size!==previousSize)window.dispatchEvent(new Event('math-viewport-change'));
   previousSize=size;
  };
  window.scrollTo(0,0);sync();window.addEventListener('scroll',sync,{passive:true});
  window.addEventListener('resize',sync);window.visualViewport?.addEventListener('resize',sync);window.visualViewport?.addEventListener('scroll',sync);coarse.addEventListener('change',sync);
  return ()=>{window.removeEventListener('scroll',sync);window.removeEventListener('resize',sync);window.visualViewport?.removeEventListener('resize',sync);window.visualViewport?.removeEventListener('scroll',sync);coarse.removeEventListener('change',sync);wrapper.classList.remove('template-wrapper--activity-page','template-wrapper--math-mobile');for(const name of ['--activity-scroll-x','--activity-scroll-y','--math-viewport-width','--math-viewport-height','--math-viewport-left','--math-viewport-top'])wrapper.style.removeProperty(name);body.classList.remove('activity-page-open','math-mobile-open');html.classList.remove('activity-page-open','math-mobile-open');window.scrollTo(previousX,previousY);};
 },[ref]);
 return mobile;
}
